export default "__VITE_ASSET__B$odYqZs__"